import { LikertAnswerGroupData } from '../../../Models/AssessmentData';

const DefaultLikertAnswerGroupData: LikertAnswerGroupData = {
    id: '',
    groupName: '',
    answers: [],
};

export default DefaultLikertAnswerGroupData;
